/**
 * Shared PrimeNG DynamicDialog config for every Care Plan modal.
 *
 * No default close affordances (mask/escape/`X`) so every close path funnels
 * through each dialog's own `tryClose()` unsaved-changes guard (D18),
 * mirroring Financial Snapshot's edit dialog.
 *
 * `width` is fixed here rather than left to each dialog's `min-width` so modal
 * content cannot resize the overlay as fields appear.
 */
export const CARE_PLAN_DIALOG_OPTIONS = {
  showHeader: false,
  modal: true,
  closable: false,
  dismissableMask: false,
  closeOnEscape: false,
  width: '32rem',
} as const;

/**
 * Open Case needs two full-width classification fields side by side. Keep it
 * wider than the other Care Plan dialogs while retaining their close guards.
 */
export const OPEN_CASE_DIALOG_OPTIONS = {
  ...CARE_PLAN_DIALOG_OPTIONS,
  width: '44rem',
  breakpoints: {
    '768px': 'calc(100vw - 2rem)',
  },
} as const;
